// import { Scene, Vector3 } from '@babylonjs/core';
import { Scene } from '@babylonjs/core/scene'
import { Vector3 } from '@babylonjs/core/Maths/math.vector'
import { DirectionalLight } from '@babylonjs/core/Lights/directionalLight'
import { PointLight } from '@babylonjs/core/Lights/pointLight'
import { ShadowGenerator } from '@babylonjs/core/Lights/Shadows/shadowGenerator'
import { AbstractMesh } from '@babylonjs/core/Meshes/abstractMesh'
import { HDRCubeTexture } from '@babylonjs/core'

const helihangarHDR = require('../images/int_helihangar_2011_sw.hdr')

export abstract class LightHelper {

  private static _lights: (DirectionalLight | PointLight)[] = [];
  public static AddLight(light: (DirectionalLight | PointLight)) { this._lights.push(light) };
  public static get lights() { return this._lights };

  private static _shadowGenerator: ShadowGenerator;
  public static get shadowGenerator() { return this._shadowGenerator }

  public static CreateDefaultLighting(scene: Scene) {

    // Point Lights
    let pointLight1 = new PointLight("pointLight1", new Vector3(1, 1, 1), scene);
    pointLight1.intensity = .3;
    this.AddLight(pointLight1);

    let pointLight2 = new PointLight("pointLight2", new Vector3(1, 1, -1), scene);
    pointLight2.intensity = .25
    this.AddLight(pointLight2);

    let pointLight3 = new PointLight("shadowLight", new Vector3(-1, 1, 0), scene);
    this.AddLight(pointLight3);

    // HDRI
    let hdri = new HDRCubeTexture(helihangarHDR, scene, 128);
    scene.environmentTexture = hdri;
  }

  public static CreateShadowGenerator() {
    let shadowGenerator = new ShadowGenerator(1024, this.lights[2]);
    shadowGenerator.usePoissonSampling = true;
    shadowGenerator.bias = .0003;
    this._shadowGenerator = shadowGenerator;
  }

  public static MakeShadowCaster(mesh: AbstractMesh) {
    this._shadowGenerator.getShadowMap()?.renderList?.push(mesh)
  }

  public static CleanupLights() {
    this._lights = []
  }
}